var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(!_vm.hideFooterAndHeader)?_c('HeaderBar'):_vm._e(),_c('div',{staticClass:"page-main"},[_c('router-view')],1),(!_vm.hideFooterAndHeader)?_c('FooterBar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }